<template>
	<v-select
		v-model="sel.value"
		:outlined="sel.outlined"
		:items="sel.items"
		:label="sel.label"
		:class="sel.class"
		:dark="sel.dark"
		dense
		:solo="sel.solo"
		:prepend-icon="sel.prependicon"
		:error-messages="sel.errorMessage"
		:hide-details="sel.hideDetail"
		@change="$emit('change', $event)"
		@click="$emit('click', $event)"
		style="min-height:36px;"
		:disabled="disable"
		:height="sel.height"
		:clearable="sel.clearable"
		:return-object="sel.returnObject"
		:item-value="sel.itemValue"
		:item-text="sel.itemText"
		:placeholder="sel.placeholder"
		:item-color="sel.itemColor ? sel.itemColor : $store.state.PointColor1"
		:color="sel.color ? sel.color : $store.state.PointColor1"
	>
	</v-select>
</template>

<script>
export default {
	props: {
		sel: Object,
		change: Function,
		disable: Boolean,
	},
	methods: {
		changeDummy() {},
	},
}
</script>

<style>
.counselorpage {
	background: none !important;
}
.selectNum {
	background: none !important;
	font-weight: bold;
}
.selectNum .v-input__control .v-input__slot {
	padding: 0px 0px 0px 7px !important;
}
</style>
